import { useTranslations } from "next-intl";
import { useCallback } from "react";

import { openDelegationModal } from "@/components/modal/delegation-modal";
import { toast } from "@/components/toast";
import { useWriteDexSdk } from "@/contexts/write-dex-sdk-context";

export const useRequireDelegation = () => {
  const { writeDexSdk } = useWriteDexSdk();
  const tDelegation = useTranslations("toast.delegation");
  const tGeneral = useTranslations("general");

  const requireDelegation = useCallback(
    (callback: () => void) => () => {
      if (!writeDexSdk) {
        openDelegationModal();
        toast({
          title: tGeneral("actionRequired"),
          description: tDelegation("actionRequiresDelegation"),
          variant: "info",
        });
        return;
      }
      callback();
    },
    [writeDexSdk, tGeneral, tDelegation],
  );

  return requireDelegation;
};

export const useValidateDelegationRequirement = () => {
  const { writeDexSdk } = useWriteDexSdk();
  const tDelegation = useTranslations("toast.delegation");
  const tGeneral = useTranslations("general");

  const validateDelegationRequirement = useCallback(() => {
    if (!writeDexSdk) {
      openDelegationModal();
      toast({
        title: tGeneral("actionRequired"),
        description: tDelegation("actionRequiresDelegation"),
        variant: "info",
      });
      return false;
    }
    return true;
  }, [writeDexSdk, tGeneral, tDelegation]);

  return validateDelegationRequirement;
};
